import { isWeb } from "@medbillai/ui";

/** The frosted plate intake heroes lay over a photo. */
export const GLASS_FILL = "rgba(255, 255, 255, 0.14)";
export const GLASS_STROKE = "rgba(255, 255, 255, 0.25)";

export const GLASS_BLUR = isWeb
  ? { backdropFilter: "blur(10px)", WebkitBackdropFilter: "blur(10px)" }
  : undefined;

/** The light glass the social-proof panels sit in over the sky: near-white, heavily blurred, with a hairline highlight along the top edge. */
export const GLASS_LIGHT_FILL = "rgba(255, 255, 255, 0.46)";
export const GLASS_LIGHT_STYLE = isWeb
  ? {
      backdropFilter: "blur(26px) saturate(150%)",
      WebkitBackdropFilter: "blur(26px) saturate(150%)",
      boxShadow:
        "inset 0 1.5px 0 rgba(255, 255, 255, 0.85), inset 0 0 0 1px rgba(255, 255, 255, 0.5)",
    }
  : undefined;
